<template>
  <div>
    <!-- <b-breadcrumb style="background-color:#f8f9fa" :items="itemsBreadcrumb"></b-breadcrumb> -->
    <b-row>
      <b-col cols="12">
      
          <b-card
            no-body
            class="shadow-sm pt-0 pl-0 pr-0 m-4 mb-0"
          >
            <b-navbar
              class="background-white"
              toggleable="lg"
            >
              <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
              <b-navbar-brand href="#">
                <strong style="color: #3b3e66">Manage Employee</strong>
              </b-navbar-brand>

              <b-collapse
                id="nav-collapse"
                is-nav
              >
                <b-navbar-nav class="ml-auto">
                  <b-nav-form>
                    <b-button
                      to="/add-employee-form"
                      class="mr-2"
                      variant="outline-primary"
                      size="sm"
                    >
                      Add Employee
                    </b-button>
                    <b-button
                      class="mr-2"
                      variant="outline-success"
                      size="sm"
                      :disabled="employeesData.length == 0 ? true : false"
                      @click="renewMultipleEmployees"
                    >
                      Renew
                    </b-button>
                    <b-button
                      class="mr-2"
                      variant="outline-success"
                      size="sm"
                      @click="selectSendFormsMultipleEmployees"
                    >
                      Select Send Forms
                    </b-button>
                    <b-button
                      class="mr-2"
                      variant="outline-danger"
                      size="sm"
                      :disabled="employeesData.length == 0 ? true : false"
                      @click="terminateMultipleEmployees"
                    >
                      Archive
                    </b-button>
                    <b-button
                      class="mr-2"
                      variant="outline-dark"
                      size="sm"
                      @click="exportEmployeeDateData"
                    >
                      Export
                    </b-button>

                    <b-button
                      class="mr-2"
                      variant="outline-dark"
                      size="sm"
                      @click="exportEmployeeData"
                    >
                      Export All
                    </b-button>

                    <b-button
                      class="mr-2"
                      variant="outline-warning"
                      size="sm"
                      @click="bulkUploadEmployee"
                    >
                      Bulk Upload
                    </b-button>
                    <b-button
                      variant="outline-info"
                      size="sm"
                      class="mr-2"
                      @click="reloadTable"
                    >
                      Reload
                    </b-button>
                    <b-form onSubmit="return false;">
                      <b-input-group size="sm">
                        <b-form-input
                          type="search"
                          @input="onEmpltyFilter($event)"
                          v-model="filter"
                          @keyup.enter="submitSearch"
                          placeholder="Type to Search"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button
                            :disabled="!filter"
                            variant="outline-success"
                            @click="submitSearch"
                          >Search</b-button>
                          <b-button
                            :disabled="!filter"
                            @click="setFIlterClear"
                          >Clear</b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form>
                    <!-- <b-form-group>
                      <b-input-group size="sm">
                        <b-form-input
                          v-model="filter"
                          type="search"
                          placeholder="Type to Search"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button
                            :disabled="!filter"
                            @click="filter = ''"
                          >Clear</b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group> -->
                  </b-nav-form>
                </b-navbar-nav>
              </b-collapse>
            </b-navbar>
        <b-overlay
          :show="isLoading"
          rounded="sm"
        >   
            <b-table
              class="main-table"
              hover
              striped
              sticky-header="calc(100vh - 295px)"
              ref="table"
              id="governance-data-table"
              :busy.sync="isLoading"
              :fields="staticFields"
              :items="setGovernanceTableData"
              :filter="filterTable ? filter : null"
              :per-page="perPage"
              :current-page="currentPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              selectable
              select-mode="single"
              @row-selected="onSelectRow"
              no-sort-reset
            >
              <template v-slot:table-colgroup="scope">
                <col
                  v-for="field in scope.fields"
                  :key="field.key"
                  :style="field.width ? 'width:' + field.width : ''"
                />
              </template>
              <template v-slot:head(checkbox)>
                <div class="text-center">
                  <b-form-checkbox
                    v-model="selectedEmployee"
                    value="1"
                    unchecked-value="0"
                    @input="selectAllRows($event)"
                  > </b-form-checkbox>
                </div>
              </template>
              <template v-slot:cell(checkbox)="data">
                <div class="text-center">
                  <b-form-checkbox
                    v-model="selectedEmployeeList[data.index]"
                    value="1"
                    unchecked-value="0"
                    @input="selectMultipleRows($event, data)"
                  > </b-form-checkbox>
                </div>
              </template>
              <template v-slot:cell(first_name)="data">
                <p
                  class="link-text"
                  @click="OpenProfilePage('/employee-profile/' + data.item.id)"
                >
                  {{ data.item.first_name }}
                </p>
              </template>
              <template v-slot:cell(last_name)="data">
                <p
                  class="link-text"
                  @click="OpenProfilePage('/employee-profile/' + data.item.id)"
                >
                  {{ data.item.last_name }}
                </p>
              </template>
              <template v-slot:cell(department)="data">
                {{data.item.department}}
              </template>
              <template v-slot:cell(country)="data">
                {{data.item.country}}
              </template>

              <template v-slot:cell()="data">
                <div v-if="setTasksColumns.length > 0">
                  <div
                    v-for="(tasksColumns, tasksColumnsIndex) in setTasksColumns"
                    :key="tasksColumnsIndex"
                  >
                    <div
                      v-for="(tasks, tasksIndex) in data.item.employee_governance_training.tasks"
                      :key="tasksIndex"
                    >
                      <div v-if="setTasksKeyConditon(data, tasks, tasksColumns)">
                        <span v-if="tasks.task_status == '0'">
                          <font-awesome-icon
                            size="lg"
                            icon="hourglass-half"
                          />
                        </span>
                        <span v-if="tasks.task_status == '1'">
                          <font-awesome-icon
                            size="lg"
                            icon="hourglass-half"
                          />
                        </span>
                        <b-badge
                          v-if="tasks.task_status == '2'"
                          variant="danger"
                        >On hold</b-badge>
                        <b-badge
                          v-if="tasks.task_status == '3'"
                          variant="dark"
                        >Review</b-badge>
                        <span
                          class="text-success"
                          v-if="tasks.task_status == '4'"
                        >
                          <font-awesome-icon
                            size="lg"
                            icon="check-circle"
                          />
                        </span>
                        <div class="text-center">
                          <!-- <span>Last completed:</span> -->
                          <!-- formatDate(tasks.updated_at) -->
                          <!--   https://ethixbase.atlassian.net/browse/EB2-51025 -->
                          <span class="" v-if="tasks.last_completed_version.version !== ''">
                         {{ formatDate(tasks.updated_at, "MMM") }} {{ formatDate(tasks.updated_at, "YYYY") }} ({{tasks.last_completed_version.version}})
                            <!-- {{ formatDate(tasks.created_at, "YYYY") }} -->
                          </span>
                          <span class="" v-else-if="tasks.version==null">
                          {{ formatDate(tasks.created_at, "MMM") }} {{ formatDate(tasks.created_at, "YYYY") }}
                            <!-- {{ formatDate(tasks.created_at, "YYYY") }} -->
                          </span>
                          <span class="" v-else>
                          {{ formatDate(tasks.created_at, "MMM") }} {{ formatDate(tasks.created_at, "YYYY") }} ({{tasks.version}})
                            <!-- {{ formatDate(tasks.created_at, "YYYY") }} -->
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-slot:cell(actions)="data">
                <b-btn
                  size="sm"
                  @click="renewForms(data)"
                  variant="outline-success"
                >Renew</b-btn>
              </template>
            </b-table>
            <!-- <template v-slot:footer> -->
              <b-row>
                <b-col cols="2">
                  <b-form-select
                    v-model="perPage"
                    id="perPageSelect"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select>
                </b-col>
                <b-col cols="6">
                  <p class="text-center">
                    Displaying Result From
                    <b>{{ fromRows }}</b> to
                    <b>{{ toRows }}</b>
                  </p>
                </b-col>
                <b-col cols="4">
                  <b-pagination
                    class="float-right"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last"
                    aria-controls="governance-data-table"
                  ></b-pagination>
                </b-col>
              </b-row>
            <!-- </template> -->
        </b-overlay>

          </b-card>
        <b-modal
          hide-header
          v-model="showRenewForm"
          size="md"
          no-close-on-backdrop
          no-close-on-esc
          hide-header-close
          :hide-footer="processing"
        >
          <div>
            <div
              v-if="processing"
              style="display: flex;justify-content: center;"
            >
              <div
                class="text-center p-4 bg-warning text-light rounded"
                style="width: 25%;"
              >
                <font-awesome-icon
                  size="lg"
                  icon="cloud-upload-alt"
                />
                <div class="mb-3">Renewing...</div>
                <b-progress
                  min="1"
                  max="20"
                  :value="counter"
                  variant="success"
                  height="3px"
                  class="mx-n4 rounded-0"
                ></b-progress>
              </div>
            </div>
            <div
              v-else
              ref="dialog"
              tabindex="-1"
              role="dialog"
              aria-modal="false"
              aria-labelledby="form-confirm-label"
              class="p-3"
            >
              <b-form-group label="Select Language">
                <multiselect
                  v-model="selectedLanguage"
                  label="text"
                  track-by="text"
                  :options="languagesOptions"
                ></multiselect>
              </b-form-group>
              <div class="mt-4 text-center">
                <p v-if="employeesData.length > 1">
                  <strong id="form-confirm-label">Are you sure you want to renew employees?</strong>
                </p>
                <p v-else>
                  <strong id="form-confirm-label">Are you sure you want to renew {{ firstName + " " + lastName }}?</strong>
                </p>
              </div>
            </div>
          </div>
          <template v-slot:modal-footer>
            <b-button
              variant="outline-danger"
              @click="renewFormCall(1)"
            >Same as Initial Email</b-button>
            <b-button
              variant="outline-success"
              class="mr-3"
              @click="resetRenewForms"
            >Cancel</b-button>
            <b-button
              variant="outline-danger"
              @click="renewFormCall(0)"
            >Send</b-button>
          </template>
        </b-modal>
        
         <b-modal
            title="Export with Date range"
            v-model="showSelectdDateForm"
            size="sm"
            no-close-on-backdrop
            no-close-on-esc
            hide-header-close
            >
          <div>
          
            <div
              ref="dialog"
              tabindex="-1"
              role="dialog"
              aria-modal="false"
              aria-labelledby="form-confirm-label"
              class="p-3"
            >
            <b-overlay :show="isFormsLoading">

               <b-form-group   label="Start Date:">
                  <b-form-datepicker
                    size="sm"
                    locale="en"
                    placeholder="Choose a Start Date"
                    :max="endDate"
                    v-model="startDate"
                  ></b-form-datepicker>
                  <p v-if="startDateIssue" style="color:#dc3545;font-size: 80%;">
                    Please select start date.
                  </p>
                </b-form-group>

                <b-form-group   label="End Date:">
                  <b-form-datepicker
                    size="sm"
                    locale="en"
                    placeholder="Choose a End Date"
                    :max="max"
                    :min="startDate"
                    v-model="endDate"
                  ></b-form-datepicker>
                    <p v-if="endDateIssue" style="color:#dc3545;font-size: 80%;">
                    Please select end date.
                  </p>
                </b-form-group>
    
                
            </b-overlay>
            </div>
          </div>
          <template v-slot:modal-footer>
            <b-button
              variant="outline-success"
              class="mr-3"
              @click="resetForms"
            >Cancel</b-button>
            <b-button
              variant="outline-danger"
              @click="exportDateRecord()"
            >Export</b-button>
          </template>
        </b-modal>

        <b-modal
          hide-header
          v-model="showSelectSendForm"
          size="xl"
          no-close-on-backdrop
          no-close-on-esc
          hide-header-close
        >
          <div>
            <!-- <div
              v-if="processing"
              style="display: flex;justify-content: center;"
            >
              <div
                class="text-center p-4 bg-warning text-light rounded"
                style="width: 50%;"
              >
                <font-awesome-icon
                  size="lg"
                  icon="cloud-upload-alt"
                />
                <div class="mb-3">Sending...</div>
                <b-progress
                  min="1"
                  max="20"
                  :value="counter"
                  variant="success"
                  height="3px"
                  class="mx-n4 rounded-0"
                ></b-progress>
              </div>
            </div> -->
            <div
              ref="dialog"
              tabindex="-1"
              role="dialog"
              aria-modal="false"
              aria-labelledby="form-confirm-label"
              class="p-3"
            >
            <b-overlay :show="isFormsLoading">
                <b-form-group label="Select Department">
                  <multiselect
                    v-model="selectedDepartment"
                    label="text"
                    track-by="text"
                    :clearable="true"
                    :multiple="true"
                    :options="departmentOptions"
                    placeholder="Select Department"
                    @input="individualIssue = false"
                  ></multiselect>
                </b-form-group>
                <b-form-group label="Select Individual">
                  <multiselect
                    v-model="selectedIndividual"
                    label="text"
                    track-by="text"
                    :clearable="true"
                    :multiple="true"
                    :options="individualOptions"
                    placeholder="Select Individual"
                    @input="individualIssue = false"
                  ></multiselect>
                  <p v-if="individualIssue" style="color:#dc3545;font-size: 80%;">
                    Please select department or any individual.
                  </p>
                </b-form-group>
                <b-form-group>
                  <div class="m-2 ml-0" style="align-items: center;">
                    Select Forms :
                    <div style="display: flex;flex-wrap: wrap;">
                    <div v-for="(form,index) in formsName" :key="index">
                        <b-badge class="ml-1" v-if="formsName.length" variant="success">{{form.title}}</b-badge>
                    </div>
                    </div>
                    <!-- <b-form-group
                      style="position: absolute;right: 35px;"
                      label="Filter"
                      label-for="filter-input"
                      label-cols-sm="3"
                      label-align-sm="right"
                      label-size="sm"
                      class="mb-0"
                      >
                      <b-input-group size="sm">
                        <b-form-input
                          id="filter-input"
                          v-model="filterForms"
                          type="search"
                          placeholder="Type to Search"
                        ></b-form-input>

                        <b-input-group-append>
                          <b-button :disabled="!filterForms" @click="filterForms = ''">Clear</b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group> -->
                  </div>
                  <!-- <multiselect
                    v-model="selectedForms"
                    label="text"
                    track-by="text"
                    :clearable="true"
                    :multiple="true"
                    :options="formsOptions"
                    :close-on-select="false"
                    :maxHeight="200"
                  ></multiselect> -->
                  <!-- <b-table
                    class="form-table"
                    bordered
                    sticky-header="calc(100vh - 295px)"
                    ref="table"
                    id="form-data-table"
                    :fields="staticFormFields"
                    :items="formsOptions"
                    :filter="filterForms"
                  >
                    <template v-slot:table-colgroup>
                      <col style="width: 20px" />
                    </template>
                    <template v-slot:head(checkbox)>
                      <div class="text-center">
                        <b-form-checkbox
                          v-model="selectedForms"
                          value="1"
                          unchecked-value="0"
                          @input="selectAllForms($event)"
                        > </b-form-checkbox>
                      </div>
                    </template>
                    <template v-slot:cell(checkbox)="data">
                      <div class="text-center">
                        <b-form-checkbox
                          v-model="selectedFormList[data.index]"
                          value="1"
                          unchecked-value="0"
                          @input="selectMultipleForms($event, data)"
                        > </b-form-checkbox>
                      </div>
                    </template>
                    <template v-slot:cell(title)="data">
                      <p>{{ data.item.title }}</p>
                    </template>
                  </b-table> -->
                  <vue-good-table
                    ref="groupedTable"
                    @on-selected-rows-change="selectMultipleForms"
                    :columns="tablecolumns"
                    :rows="tablerows"
                    :select-options="{ enabled: true }"
                    :search-options="{ enabled: true }"
                    :group-options="{
                      enabled: true,
                      collapsable: true 
                    }"
                    max-height="400px"
                  >
                  <template slot="table-column" slot-scope="props">
                    <span v-if="formsName.length == totalChildren ">
                      Deselect All
                    </span>
                    <span v-else>
                        {{props.column.label}}
                    </span>
                  </template>
                  </vue-good-table>
                  <p v-if="formIssue" style="color:#dc3545;font-size: 80%;">
                    Please select at least one form
                  </p>
                </b-form-group>
            </b-overlay>
            </div>
          </div>
          <template v-slot:modal-footer>
            <b-button
              variant="outline-success"
              class="mr-3"
              @click="resetForms"
            >Cancel</b-button>
            <b-button
              variant="outline-danger"
              @click="selectSendFormCall()"
            >Send</b-button>
          </template>
        </b-modal>
        <b-overlay
          :show="isSendingForm"
          no-wrap
        >
          <template v-slot:overlay>
          <div
            v-if="processing"
            class="text-center p-4 bg-warning text-light rounded"
          >
              <font-awesome-icon
                size="lg"
                icon="cloud-upload-alt"
              />
              <div class="mb-3">Sending...</div>
                <b-progress
                  min="1"
                  max="20"
                  :value="counter"
                  variant="success"
                  height="3px"
                  class="mx-n4 rounded-0"
                ></b-progress>
            </div>
          </template>
        </b-overlay>
        <b-overlay
          :show="showUpdateStatus"
          no-wrap
        >
          <template v-slot:overlay>
            <div
              v-if="processing"
              class="text-center p-4 bg-primary text-light rounded"
            >
              <font-awesome-icon
                size="lg"
                icon="cloud-upload-alt"
              />
              <div class="mb-3">Archiving...</div>
              <b-progress
                min="1"
                max="20"
                :value="counter"
                variant="success"
                height="3px"
                class="mx-n4 rounded-0"
              ></b-progress>
            </div>
            <div
              v-else
              ref="dialog"
              tabindex="-1"
              role="dialog"
              aria-modal="false"
              aria-labelledby="form-confirm-label"
              class="text-center p-3"
            >
              <p>
                <strong id="form-confirm-label">Are you sure you want archive employees ?</strong>
              </p>
              <div>
                <b-button
                  variant="outline-success"
                  class="mr-3"
                  @click="resetUpdateStatus"
                >Cancel</b-button>
                <b-button
                  variant="outline-danger"
                  @click="updateStatusCall"
                >Yes</b-button>
              </div>
            </div>
          </template>
        </b-overlay>
      </b-col>
    </b-row>
    <BulkUploadEmployee />
  </div>
</template>

<script>
import { HTTP } from "../../../utils/HTTP";
import moment from "moment";
import "moment/locale/es";
import { Helper } from "../../../helpers";
import { EventBus } from "@/event-bus.js";
import _ from "lodash";
import BulkUploadEmployee from "./bulkUploadEmployee";

export default {
  name: "OptionOne",
  components: {
    BulkUploadEmployee,
  },
  data () {
    return {
      languagesOptions: [],
      selectedLanguage: null,
      showUpdateStatus: false,
      selectedEmployee: [],
      selectedEmployeeList: [],
      checkboxValue: null,
      showRenewForm: false,
      showSelectSendForm: false,
      showSelectdDateForm:false,
      processing: false,
      counter: 1,
      interval: null,
      employeeId: null,
      firstName: null,
      lastName: null,
      itemsBreadcrumb: [
        {
          text: "Dashboard",
          href: "dashboard",
        },
        {
          text: "Onboarding",
          href: "#",
          active: true,
        },
      ],
      isLoading: false,
      totalRows: 0,
      fromRows: 0,
      toRows: 0,
      filter: null,
      perPage: 10,
      currentPage: 1,
      sortBy: "id",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 75, 100],
      governanceTableItems: [],
      setTasksColumns: [],
      staticFields: [],
      onboardingId: null,
      callFunction: true,
      employeesData: [],
      multipleEmployees: false,
      uniqEmployeeData: [],
      filterTable: false,
      departmentOptions: [],
      selectedDepartment: [],
      individualOptions: [],
      selectedIndividual: [],
      formsOptions: [],
      selectedForms: null,
      tablecolumns: [
        { field: "title", label: "Select All", sortable: false },
      ],
      selectedFormList: [],
      formsData: [],
      filterForms: null,
      formsName:[],
      isSendingForm: false,
      individualIssue: false,
      formIssue: false,
      tablerows: [],
      isFormsLoading: false,
      totalChildren: 0,
      startDate:"",
      endDate:"",
      startDateIssue:false,
      endDateIssue:false,
    };
  },
  mounted () {
    this.getEmployeeLanguages();
  },
  computed: {
    rows () {
      return this.totalRows;
    },
  },
  beforeDestroy () {
    this.clearInterval();
  },
  methods: {
    async getDepartments(){
      this.isFormsLoading = true;
      this.departmentOptions = [];
      try {
        let result = await HTTP( "post", "api/v1/department/get/active", null );
        this.departmentOptions = result.data;
        this.isFormsLoading = false;
      } catch ( error ) {
        this.isFormsLoading = false;
      }
    },
    async getIndividuals(){
      this.isFormsLoading = true;
      this.individualOptions = [];
      try {
        let result = await HTTP( "post", "api/v1/employees/get-employee-list/active", null );
        this.individualOptions = result.data;
        this.isFormsLoading = false;
      } catch ( error ) {
        this.isFormsLoading = false;
      }
    },
    async getForms (){
      this.isFormsLoading = true;
      this.tablerows = [];
      let arrOfTypes = ["policy","trainings","certification","health_and_safety_policy","health_and_safety_training"]
      let formData = {
        types: arrOfTypes,
      };
      try {
        let result = await HTTP( "post", "api/v1/forms/list/with/types", formData );
        // this.tablerows = result.data.form
        Object.keys(result.data.form).forEach((key)=> {
            this.tablerows.push({
              mode: 'span',
              label: this.$t(key),
              html: false,
              children: result.data.form[key]
            })
            this.totalChildren += result.data.form[key].length;
        });
        setTimeout( () => {
          this.$refs.groupedTable.expandAll();
        }, 150 );
        this.isFormsLoading = false;
      } catch ( error ) {
        this.isFormsLoading = false;
      }
    },
    formatDate ( value, dateFormat = "DD/MM/YYYY" ) {
      moment.locale( "en" );
      return moment( value ).format( dateFormat );
    },
    submitSearch () {
      if ( this.filter ) {
        this.filterTable = true;
      }
    },
    onEmpltyFilter ( value ) {
      if ( value ) {
        return;
      } else {
        this.setFIlterClear();
      }
    },
    setFIlterClear () {
      this.filter = "";
      this.filterTable = false;
      this.reloadTable();
    },
    async getEmployeeLanguages () {
      this.languagesOptions = [];
      try {
        let result = await HTTP( "get", "api/v1/constants/languages-list", null );
        this.languagesOptions = result.data.employeeLanuages;
      } catch ( error ) {
        this.isLoading = false;
      }
    },
    bulkUploadEmployee () {
      EventBus.$emit( "onShowBulkUploadEmployeeModal", "" );
    },
    OpenProfilePage ( url ) {
      this.$router.push( url );
    },
    terminateMultipleEmployees () {
      this.showUpdateStatus = true;
      this.uniqEmployeeData = _.uniq(
        this.employeesData
      );
    },
    exportEmployeeData () {
      let userId = localStorage.getItem( "userId" );
      this.isLoading = true;
      let result = HTTP(
        "get",
        "api/v1/governance/training/employee/rs/download/" + userId,
        null,
        null,
        null,
        null,
        "blob"
      );
      return result
        .then( response => {
          let blob = new Blob( [response.data], {
            type: "application/octet-stream"
          } );
          const url = window.URL.createObjectURL( blob );
          const link = document.createElement( "a" );
          link.href = url;
          link.setAttribute( "download", "employees.xlsx" ); //or any other extension
          document.body.appendChild( link );
          link.click();
          this.isLoading = false;
        } )
        .catch( error => {
          this.isLoading = false;
          return [error];
        } );
    },
    selectMultipleRows ( value, data ) {
      if ( value == 1 ) {
        this.firstName = data.item.first_name;
        this.lastName = data.item.last_name;
        this.employeesData.push( data.item.id );
      } else {
        let employeeIndex = this.employeesData.findIndex(
          ( x ) => x == data.item.id
        );
        this.employeesData.splice( employeeIndex, 1 );
      }
    },
    selectMultipleForms ( value ) {
      // if ( value == 1 ) {
      //   this.formIssue = false;
      //   this.formsData.push(data.item.id);
      //   this.formsName.push(data.item)
      // } else {
      //   let formIndex = this.formsData.findIndex(
      //     ( x ) => x == data.item.id
      //   );
      //   this.formsData.splice( formIndex, 1 );
      //   this.formsName.splice( formIndex, 1 );
      // }
      this.formsData = [];
      this.formsName = [];
      if(value.selectedRows.length > 0){
        this.formIssue = false;
        value.selectedRows.map((data)=>{
          this.formsData.push(data.id);
          this.formsName.push(data)
        })
      }else{
        let formIndex = this.formsData.findIndex(
          ( x ) => x == value.id
        );
        this.formsData.splice( formIndex, 1 );
        this.formsName.splice( formIndex, 1 );
      }
    },
    selectAllRows ( value ) {
      if ( value == 1 ) {
        this.governanceTableItems.map( ( items, index ) => {
          this.selectedEmployeeList[index] = 1;
          this.employeesData[index] = items.id
        } )
      } else {
        this.selectedEmployee = [];
        this.selectedEmployeeList = [];
        this.employeesData = [];
        this.uniqEmployeeData = [];
      }
    },
    selectAllForms ( value ) {
      if ( value == 1 ) {
        this.formIssue = false;
        this.formsOptions.map( ( items, index ) => {
        this.selectedFormList[index] = 1;
        this.formsData[index] = items.id
          // this.formsName[index] = items.title
        } )
      } else {
        this.selectedForms = [];
        this.selectedFormList = [];
        this.formsData = [];
        this.formsName = [];
      }
    },
    onSelectRow ( data ) {
      if ( data[0].id ) {
        this.$router.push( "/employee-profile/" + data[0].id );
      }
    },
    clearInterval () {
      if ( this.interval ) {
        clearInterval( this.interval );
        this.interval = null;
      }
    },
    renewMultipleEmployees () {
      this.multipleEmployees = true;
      this.showRenewForm = true;
      this.uniqEmployeeData = _.uniq(
        this.employeesData
      );
    },
    exportEmployeeDateData(){
       this.showSelectdDateForm = true;
    },
    selectSendFormsMultipleEmployees () {
      this.getDepartments();
      this.getIndividuals();
      this.getForms();
      this.multipleEmployees = true;
      this.showSelectSendForm = true;
      // this.uniqEmployeeData = _.uniq(
      //   this.employeesData
      // );
    },
    renewForms ( data ) {
      this.employeeId = data.item.id;
      this.firstName = data.item.first_name;
      this.lastName = data.item.last_name;
      this.showRenewForm = true;
    },

    exportDateRecord(){
       if( this.startDate.length == 0 || this.endDate.length == 0){
          if(this.startDate.length == 0 ){
             this.startDateIssue = true;
          }else{
            this.startDateIssue = false;
          }

          if( this.endDate.length == 0){
            this.endDateIssue = true;
          }else{
             this.endDateIssue = false;
          }
       }else{

         this.startDateIssue = false;
         this.endDateIssue = false;
         // 
         this.exportDateRecordApiCall();
         
         
       }

    },
    async exportDateRecordApiCall () {

      let userId = localStorage.getItem( "userId" );
      this.isLoading = true;
      let formData = {
        start_date: this.startDate,
        end_date: endDate,
        user_id: localStorage.getItem( "userId" ),
      };
     let result = HTTP(
        "post",
        "api/v1/governance/training/employee/rs/dateDataDownload",
        formData
      );
    /*
      let result = HTTP(
        "get",
        "api/v1/governance/training/employee/rs/download/" + userId,
        null,
        null,
        null,
        null,
        "blob"
      );
      */
      return result
        .then( response => {
          let blob = new Blob( [response.data], {
            type: "application/octet-stream"
          } );
          const url = window.URL.createObjectURL( blob );
          const link = document.createElement( "a" );
          link.href = url;
          link.setAttribute( "download", "employees.xlsx" ); //or any other extension
          document.body.appendChild( link );
          link.click();
          this.isLoading = false;
        } )
        .catch( error => {
          this.isLoading = false;
          return [error];
        } );

    },
    exportDateRecord(){
      if( this.startDate.length == 0 || this.endDate.length == 0){        
        if(this.startDate.length == 0 ){
          this.startDateIssue = true;
        }else{
          this.startDateIssue = false;
        }
        if( this.endDate.length == 0){
            this.endDateIssue = true;
        }else{
            this.endDateIssue = false;
        }
      }else{
        this.startDateIssue = false;
        this.endDateIssue = false;
        // 
        this.exportDateRecordApiCall();
      }
    },
    async exportDateRecordApiCall (){
      let userId = localStorage.getItem( "userId" );
      this.isLoading = true;
      let formData = {
        start_date: this.startDate,
        end_date: this.endDate,
        user_id:userId,
      };
      let result = HTTP(
        "post",
        "api/v1/governance/training/employee/rs/download/date",
        formData,
        null,
        null,
        null,
        "blob",
      );      
      return result
        .then( response => {
          let blob = new Blob( [response.data], {
            type: "application/octet-stream"
          } );
          this.resetForms();
          const url = window.URL.createObjectURL( blob );
          const link = document.createElement( "a" );
          link.href = url;
          link.setAttribute( "download", "employeesDate.xlsx" ); //or any other extension
          document.body.appendChild( link );
          link.click();
          this.isLoading = false;
        } )
        .catch( error => {
          this.resetForms();
          this.isLoading = false;
          return [error];
        });
    }, 
    selectSendFormCall () {
      if(( this.selectedDepartment.length == 0 && this.selectedIndividual.length == 0 ) || this.formsName.length == 0){
        if ( this.selectedDepartment.length == 0 && this.selectedIndividual.length == 0 ) {
          this.individualIssue = true;
          // Helper.makeToast( this.$bvToast, "danger", "Please select department or any individual" );
        }
        if( this.formsName.length == 0 ){
          this.formIssue = true;
          // Helper.makeToast( this.$bvToast, "danger", "Please select at least one form" );
        }
      }else{
        this.individualIssue = false;
        this.formIssue = false;
        this.showSelectSendForm = false
        this.isSendingForm = true
        this.counter = 1;
        this.processing = true;
        this.selectSendFormApiCall();
        this.clearInterval();
        this.interval = setInterval( () => {
          if ( this.counter < 20 ) {
            this.counter = this.counter + 1;
          } else {
            this.clearInterval();
            this.$nextTick( () => {
              this.resetForms();
            } );
          }
        }, 100 );
      }
    },

    async selectSendFormApiCall () {
        let departmentArray = [];
        let empArray = [];
        let forms = [];
        let policyForms = this.formsName.filter( form => form.type == "policy" )
        let trainingForms = this.formsName.filter( form => form.type == "trainings" )
        let certificationForms = this.formsName.filter( form => form.type == "certification" )
        let healthAndSaftyPolicyForms = this.formsName.filter( form => form.type == "health_and_safety_policy" )
        let healthAndSaftyTrainingForms = this.formsName.filter( form => form.type == "health_and_safety_training" )

        policyForms.map((data)=>{
          let typeIndex = this.formsName.findIndex(
            ( x ) => x.id == data.id
          );
          if(typeIndex != -1){
          let relatedForms = JSON.parse(data.related_form_ids);
            forms.push({
                  text: data.title,
                  value: data.id,
                  reletedFormIds: [
                    {
                      type: relatedForms && relatedForms[0].type ? relatedForms[0].type : '',
                      formId: relatedForms && relatedForms[0].formId ? relatedForms[0].formId : '',
                      is_active: relatedForms && relatedForms[0].is_active ? relatedForms[0].is_active : '',
                      onboarding_form_versions_id: relatedForms && relatedForms[0].onboarding_form_versions_id ? relatedForms[0].onboarding_form_versions_id: '',
                    }
                  ]
              })
          }
        })
        policyForms = {};
        if(forms.length > 0) {
          policyForms = {
              forms: forms
          };
        }
        forms = []
        trainingForms.map((data)=>{
          let typeIndex = this.formsName.findIndex(
            ( x ) => x.id == data.id
          );
          if(typeIndex != -1){
          let relatedForms = JSON.parse(data.related_form_ids);
            forms.push({
                  text: data.title,
                  value: data.id,
                  reletedFormIds: [
                    {
                      type: relatedForms && relatedForms[0].type ? relatedForms[0].type : '',
                      formId: relatedForms && relatedForms[0].formId ? relatedForms[0].formId : '',
                      is_active: relatedForms && relatedForms[0].is_active ? relatedForms[0].is_active : '',
                      onboarding_form_versions_id: relatedForms && relatedForms[0].onboarding_form_versions_id ? relatedForms[0].onboarding_form_versions_id: '',
                    }
                  ]
              })
          }
        })
        trainingForms = {};
        if(forms.length > 0) {
          trainingForms = {
              forms: forms
          };
        }
        forms = []
        certificationForms.map((data)=>{
          let typeIndex = this.formsName.findIndex(
            ( x ) => x.id == data.id
          );
          if(typeIndex != -1){
          let relatedForms = JSON.parse(data.related_form_ids);
            forms.push({
                  text: data.title,
                  value: data.id,
                  reletedFormIds: [
                    {
                      type: relatedForms && relatedForms[0].type ? relatedForms[0].type : '',
                      formId: relatedForms && relatedForms[0].formId ? relatedForms[0].formId : '',
                      is_active: relatedForms && relatedForms[0].is_active ? relatedForms[0].is_active : '',
                      onboarding_form_versions_id: relatedForms && relatedForms[0].onboarding_form_versions_id ? relatedForms[0].onboarding_form_versions_id: '',
                    }
                  ]
              })
          }
        })
        certificationForms = {};
        if(forms.length > 0) {
          certificationForms = {
              forms: forms
          };
        }
        forms = []
        healthAndSaftyPolicyForms.map((data)=>{
          let typeIndex = this.formsName.findIndex(
            ( x ) => x.id == data.id
          );
          if(typeIndex != -1){
          let relatedForms = JSON.parse(data.related_form_ids);
            forms.push({
                  text: data.title,
                  value: data.id,
                  reletedFormIds: [
                    {
                      type: relatedForms && relatedForms[0].type ? relatedForms[0].type : '',
                      formId: relatedForms && relatedForms[0].formId ? relatedForms[0].formId : '',
                      is_active: relatedForms && relatedForms[0].is_active ? relatedForms[0].is_active : '',
                      onboarding_form_versions_id: relatedForms && relatedForms[0].onboarding_form_versions_id ? relatedForms[0].onboarding_form_versions_id: '',
                    }
                  ]
              })
          }
        })
        healthAndSaftyPolicyForms = {};
        if(forms.length > 0) {
          healthAndSaftyPolicyForms = {
              forms: forms
          };
        }
        forms = []
        healthAndSaftyTrainingForms.map((data)=>{
          let typeIndex = this.formsName.findIndex(
            ( x ) => x.id == data.id
          );
          if(typeIndex != -1){
          let relatedForms = JSON.parse(data.related_form_ids);
            forms.push({
                  text: data.title,
                  value: data.id,
                  reletedFormIds: [
                    {
                      type: relatedForms && relatedForms[0].type ? relatedForms[0].type : '',
                      formId: relatedForms && relatedForms[0].formId ? relatedForms[0].formId : '',
                      is_active: relatedForms && relatedForms[0].is_active ? relatedForms[0].is_active : '',
                      onboarding_form_versions_id: relatedForms && relatedForms[0].onboarding_form_versions_id ? relatedForms[0].onboarding_form_versions_id: '',
                    }
                  ]
              })
          }
        })
        healthAndSaftyTrainingForms = {};
        if(forms.length > 0) {
          healthAndSaftyTrainingForms = {
              forms: forms
          };
        }
        if(this.selectedDepartment){
          this.selectedDepartment.map((data)=>{
              departmentArray.push(data.value)
          })
        }
        if(this.selectedIndividual){
          this.selectedIndividual.map((data)=>{
              empArray.push(data.value)
          })
        }
        let formData = {
          tasks: {
            policyForms: policyForms,
            trainingForms: trainingForms,
            certificationForms: certificationForms,
            healthAndSaftyPolicy: healthAndSaftyPolicyForms,
            healthAndSaftyTraining: healthAndSaftyTrainingForms,
          },
          user_id: localStorage.getItem("userId"),
          departments: departmentArray,
          employees: empArray,
        };
        try {
          let result = await HTTP( "post", "api/v1/governance/training/multiple/additional/tasks", formData );
          if(result.data){
            if ( result.data && result.data.status == 1 ) {
              Helper.makeToast( this.$bvToast, "success", result.data.message );
            }
          }
          // this.individualOptions = result.data;
        } catch ( error ) {
            return [error];
        }
    },
    renewFormCall ( sendAsInitial ) {
      this.counter = 1;
      this.processing = true;
      if ( this.multipleEmployees ) {
        this.renewMultipleEmployeesApiCall( sendAsInitial ).then( this.reloadTable );
      } else {
        this.renewFormApiCall().then( this.reloadTable );
      }
      this.clearInterval();
      this.interval = setInterval( () => {
        if ( this.counter < 20 ) {
          this.counter = this.counter + 1;
        } else {
          this.clearInterval();
          this.$nextTick( () => {
            this.resetRenewForms();
          } );
        }
      }, 100 );
    },
    async renewMultipleEmployeesApiCall ( sendAsInitial ) {
      let formData = {
        employees: this.uniqEmployeeData,
        language: ( this.selectedLanguage && sendAsInitial == 0 ) ? this.selectedLanguage.value : 0,
        user_id: localStorage.getItem( "userId" ),
      };
      this.isLoading = true;
      let result = await HTTP(
        "post",
        "api/v1/governance/training/multiple/renew",
        formData
      );
      try {
        this.isLoading = false;
        if ( result.data && result.data.status == 1 ) {
          Helper.makeToast( this.$bvToast, "success", result.data.message );
        }
      } catch ( err ) {
        this.isLoading = false;
        return [err];
      }
    },
    async renewFormApiCall () {
      let formData = {
        employee_id: this.employeeId,
        language: this.selectedLanguage ? this.selectedLanguage.value : '1',
        user_id: localStorage.getItem( "userId" ),
      };
      this.isLoading = true;
      let result = await HTTP(
        "post",
        "api/v1/governance/training/renew",
        formData
      );
      try {
        this.isLoading = false;
        if ( result.data && result.data.status == 1 ) {
          Helper.makeToast( this.$bvToast, "success", result.data.message );
        }
      } catch ( err ) {
        this.isLoading = false;
        return [err];
      }
    },
    resetRenewForms () {
      this.showRenewForm = this.processing = this.multipleEmployees = this.isSendingForm = false;
      this.selectedLanguage = null
      this.statusKey = 0;
      this.employeeId = null;
      this.firstName = null;
      this.lastName = null;
      this.selectedEmployee = [];
      this.selectedEmployeeList = [];
      this.employeesData = [];
      this.uniqEmployeeData = [];
    },
    resetForms () {
      this.showSelectSendForm = false;
      this.showSelectdDateForm = false;
      this.individualIssue = false;
      this.formIssue = false;
      this.totalChildren = 0;
      this.endDate="";
      this.startDate="";
      this.startDateIssue=false;
      this.endDateIssue=false;
      this.selectedDepartment = [];
      this.selectedIndividual = [];
      this.selectedForms = [];
      this.selectedFormList = [];
      this.formsData = [];
      this.formsName = [];
      this.resetRenewForms();
    },
    updateStatusCall () {
      this.counter = 1;
      this.processing = true;
      this.updateMultipleEmployeeStatusApiCall().then( this.reloadTable );
      this.clearInterval();
      this.interval = setInterval( () => {
        if ( this.counter < 20 ) {
          this.counter = this.counter + 1;
        } else {
          this.clearInterval();
          this.$nextTick( () => {
            this.resetUpdateStatus();
          } );
        }
      }, 100 );
    },
    async updateMultipleEmployeeStatusApiCall () {
      let formData = {
        employees: this.uniqEmployeeData,
        status: 3,
        user_id: localStorage.getItem( "userId" ),
      };
      this.isLoading = true;
      let result = await HTTP(
        "post",
        "api/v1/employees/multiple/update/status",
        formData
      );
      try {
        this.isLoading = false;
        if ( result.data && result.data.status == 1 ) {
          Helper.makeToast( this.$bvToast, "success", result.data.message );
        }
      } catch ( err ) {
        this.isLoading = false;
        return [err];
      }
    },
    resetUpdateStatus () {
      this.showUpdateStatus = this.processing = this.multipleEmployees = false;
      this.selectedEmployee = [];
      this.selectedEmployeeList = [];
      this.employeesData = [];
      this.uniqEmployeeData = [];
    },
    reloadTable () {
      this.$root.$emit( "bv::refresh::table", "governance-data-table" );
    },
    setTasksKeyConditon ( data, tasks, tasksColumns ) {
      let tasksKey = tasks.task_title.toLowerCase().replace( /\s/g, "_" );
      if ( data.field.key == tasksKey ) {
        if ( tasksKey == tasksColumns.key ) {
          if ( data.field.key == tasksColumns.key ) {
            return true;
          }
        }
      } else {
        return false;
      }
    },
    async setGovernanceTableData () {
      this.governanceTableItems = [];
      this.staticFields = [];
      this.setTasksColumns = [];
      let formData = {
        filter: this.filter,
        sort: this.sortBy + "|" + ( this.sortDesc == true ? "desc" : "asc" ),
        per_page: this.perPage,
        page: this.currentPage,
      };
      this.isLoading = true;
      let token = "Bearer " + localStorage.getItem( "accessToken" );
      try {
        const response = await HTTP(
          "post",
          "api/v1/governance/training/data",
          formData,
          {
            Authorization: token,
          }
        );
        this.setTasksHeadings( response );
        this.governanceTableItems = response.data.data;
        this.filterTable = false;
        this.totalRows = response.data.total;
        this.fromRows = response.data.from;
        this.toRows = response.data.to;
        return response.data.data;
      } catch ( err ) {
        this.isLoading = false;
        return [err];
      }
    },
    setTasksHeadings ( response ) {
      // this.staticFields = 
      this.staticFields = [
        { key: "checkbox", label: "", sortable: false },
        { key: "first_name", label: "First Name", sortable: true },
        { key: "last_name", label: "Last Name", sortable: true },
        { key: "department", label: "Division Unit", sortable: true },
        { key: "country", label: "Country", sortable: true }
      ];
      this.setTasksColumns = [];
      response.data.data.map( ( tableData, index ) => {
        tableData.employee_governance_training.tasks.map( ( tasksItems ) => {
          let fieldKey = tasksItems.task_title
            .toLowerCase()
            .replace( /\s/g, "_" );
          // if ( index == 0 ) {
            let index = -1;
            this.staticFields.map( ( item, indexValue ) => {
              if(item.key == fieldKey) {
                index = indexValue;
              }
            } )
            if(index == -1) {
                this.staticFields.push( {
                key: fieldKey,
                label: tasksItems.task_title,
                sortable: false,
              } );
              this.setTasksColumns.push( {
                key: fieldKey,
                text: tasksItems.task_title,
                form_type: tasksItems.form_type,
              } );
            }             
          // }
        } );
      } );
      this.isLoading = false;
      // if ( this.callFunction ) {
      //   this.reloadTable();
      // }
      // this.callFunction = false;
    },
  },
};
</script>

<style scoped>
@import "../../../assets/styles/theme1/tabs.css";
@import "../../../assets/styles/theme1/timeline.css";

.card-body {
  padding: 0px;
}

.fixed-bottom {
  right: auto !important;
  left: auto !important;
  width: 100%;
}
</style>

<style>
body {
  font-family: Heebo, sans-serif;
  font-size: 0.95rem;
  font-weight: 400;
  line-height: 1.5;
  color: #3b3e66;
}

.card-header {
  /* #background-color:#dcdef1; */
  /* padding: 0.4rem 0.4rem; */

  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #fff;
  border-bottom: 0 solid rgba(122, 123, 151, 0.3);
}

/* .table .thead-light th {
    color: #3b3e66;
    background-color: rgba(239,239,247,.7);
    border-color: #dcdef1;
} */
.table {
  font-size: 0.83125rem;
  color: #3b3e66;
}

.table.b-table > thead > tr .table-b-table-default {
  background-color: rgba(239, 239, 247, 0.7);
  color: #3b3e66;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: #f9fafe;
  color: #3b3e66;
}

.table thead th {
  text-transform: uppercase;
  font-size: 0.83125rem;
  border-color: #dcdef1;
  vertical-align: bottom;
  border-bottom: 2px solid #dcdef1;
}

.form-group {
  margin-bottom: 0rem;
}

.group-prepend > .btn,
.input-group-sm > .input-group-append > .btn {
  font-size: 0.75rem;
}

.progress {
  height: 0.5rem;
}

.btn-sm {
  font-size: 0.75rem;
}

</style>
